import { endOfDay, startOfDay } from 'date-fns'
import { FormEvent, useState } from 'react'
import { DateRange } from 'react-day-picker'

type StatementFilterParams = {
  startDate: string
  endDate?: string
}

type UseSellerStatementFilterControllerProps = {
  onFilter: (params: StatementFilterParams) => void
  onClear: () => void
}

export const useSellerStatementFilterController = ({
  onFilter,
  onClear,
}: UseSellerStatementFilterControllerProps) => {
  const [selectedDate, setSelectedDate] = useState<DateRange | undefined>()

  const handleDateChange = (dateRange: DateRange | undefined) => {
    setSelectedDate(dateRange)
  }

  const handleClearFilter = () => {
    setSelectedDate(undefined)
    onClear()
  }

  const handleFilterSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!selectedDate?.from) {
      onClear()
      return
    }

    const rangeEnd = selectedDate.to ?? selectedDate.from

    onFilter({
      startDate: endOfDay(rangeEnd).toISOString(),
      endDate: startOfDay(selectedDate.from).toISOString(),
    })
  }

  return {
    selectedDate,
    handleDateChange,
    handleClearFilter,
    handleFilterSubmit,
  }
}
